import React, { useEffect, useRef, useState } from "react";
import PackShowcase from "@/components/PackShowcase";
import { useCatalog } from "@/context/CatalogContext";

const STEP = 3;

export default function PacksPage({ config }) {
  const { packs } = useCatalog();
  const [shown, setShown] = useState(STEP);
  const sentinel = useRef(null);

  useEffect(() => {
    if (!sentinel.current || shown >= packs.length) return;
    const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) setShown((n) => Math.min(packs.length, n + STEP)); }, { rootMargin: "600px" });
    io.observe(sentinel.current);
    return () => io.disconnect();
  }, [shown, packs.length]);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="mb-10">
        <div className="font-mono text-xs text-red-500 uppercase tracking-[0.3em] mb-2">Packs bimestrales</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white">
          Packs
        </h1>
        <p className="text-white/50 mt-4 max-w-xl">Cada par de meses lanzo un pack con lo mejor. Descárgalo entero.</p>
      </div>

      {packs.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl py-24 text-center text-white/40">
          Aún no hay packs publicados.
        </div>
      ) : (
        <div className="space-y-5" data-testid="packs-grid">
          {packs.slice(0, shown).map((p) => <PackShowcase key={p.id} pack={p} config={config} />)}
          {shown < packs.length && <div ref={sentinel} className="h-10" data-testid="packs-more-sentinel" />}
        </div>
      )}
    </div>
  );
}
